module.exports = __webpack_public_path__ + "img/IT0000104747739.c41cd6a0.png";